import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { selectAuthGuardState } from '../../features/auth/selectors/auth.selectors';
import { TokenManager } from '../../utils/storage/tokenmanager.storage';
import LoadingSpinner from '../ui/LoadingSpinner';

interface GuestRouteProps {
  children: JSX.Element;
}

const GuestRoute: React.FC<GuestRouteProps> = React.memo(({ children }) => {
  const { user, isLoading } = useAppSelector(selectAuthGuardState);
  const location = useLocation();

  if (isLoading && !user && TokenManager.isAuthenticated()) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <LoadingSpinner size="lg" color="orange" />
      </div>
    );
  }

  const isAuthenticated = !!user || TokenManager.isAuthenticated();

  if (isAuthenticated) {
    // If we have a stored redirect path, use it
    const from = location.state?.from?.pathname || localStorage.getItem('redirectAfterLogin') || '/';
    localStorage.removeItem('redirectAfterLogin');
    return <Navigate to={from} replace />;
  }

  return children;
});

export default GuestRoute;
